import script from "./EntityForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./EntityForm.vue?vue&type=script&lang=ts&setup=true"

import "./EntityForm.vue?vue&type=style&index=0&id=2db21745&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2db21745"]])

export default __exports__